import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0C10] text-[#8A99AD]">
        <span className="font-display uppercase tracking-widest">Lade…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
